import type {
  SalesforceEntity,
  SalesforceNormalizedEntity,
  SalesforceTask,
} from '../../../../domain/salesforceActivity';

import { isSalesforceAccountTask } from './type-guards';

export const getEntityIdForTask = (task: SalesforceTask): string =>
  isSalesforceAccountTask(task) ? task.whatId : task.whoId;

export const getTasksForEntity = (entityId: string, tasks: readonly SalesforceTask[]): readonly SalesforceTask[] =>
  tasks.filter((task) => getEntityIdForTask(task) === entityId);

export const getEntityById = <T extends SalesforceEntity = SalesforceEntity>(
  entities: readonly T[],
  entityId: string
): T | undefined => entities.find((entity) => entity.id === entityId);

export const computeDefaultEntity = (
  entities: readonly SalesforceNormalizedEntity[],
  tasks: readonly SalesforceTask[]
): SalesforceNormalizedEntity | undefined => {
  if (entities.length === 0) {
    return undefined;
  }

  const tasksWithDate = tasks.filter((t) => t.activityDate);
  if (tasksWithDate.length > 0) {
    const newest = tasksWithDate.reduce((a, b) => (a.activityDate! > b.activityDate! ? a : b));

    return getEntityById(entities, getEntityIdForTask(newest));
  }

  return entities[0];
};
